import { CURRICULUM_PROGRAM_TYPES } from "Constants";
import _ from "lodash";
import { getMemoizedFunction } from "Utils";

const EE_SUBJECT_TYPES = ["EE", "EE_SUBJECT"];

export const getSubjectsData = ({ allSubjects }) => {
  return _.reduce(
    allSubjects,
    (result, subject) => {
      const { id, title, type: subjectType, curriculumType } = subject;

      // filtering on FE because:
      // 1. BE supports included subject types only and not excluded in filters
      //    so if more subject types are added in future, we will have to change in everytime
      // 2. If filters is passed in variables, it requires other mandatory props
      //    that we don't have here
      // In future, we can change BE schema and add filters to query
      if (_.includes(EE_SUBJECT_TYPES, subjectType)) {
        return result;
      }

      result.push({ label: title, value: id, curriculumType });
      return result;
    },
    []
  );
};

const _getCurriculumAcronym = ({ curriculumType }) => {
  const curriculumProgram = _.find(CURRICULUM_PROGRAM_TYPES, {
    value: curriculumType,
  });
  return _.get(curriculumProgram, "label", "");
};

export const getCurriculumAcronym = getMemoizedFunction(_getCurriculumAcronym);
